import {
  styled,
  TableContainer,
  TableContainerProps,
  TableHead,
  TableHeadProps,
} from "@mui/material";

export const StyledTableContainer = styled(TableContainer)<TableContainerProps>(({theme}) => ({
  overflow: "auto",
  height: "60vh",
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.gray.main,
}));
export const StyledTableHead = styled(TableHead)<TableHeadProps>(({theme}) => ({
  backgroundColor: theme.palette.gray.dark,
  position: "sticky",
  top: 0,
  zIndex: 10,
}));
export const StyledNoneScrollTable = styled(TableContainer)<TableContainerProps>(({theme}) => ({
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.gray.main,
}));
export const StyledNoneStickyTable = styled(TableHead)<TableHeadProps>(({theme}) => ({
  backgroundColor: theme.palette.gray.dark,
}));
